export default __webpack_public_path__ + "static/media/unknown-location.b45b43bf.svg";